export default "__VITE_ASSET__BcMGePbM__"